import React from 'react';
import { PageProps, Link } from 'gatsby';
import { INovelChapter } from '@/@types/interface';
import styles from './style.module.scss';

interface IDetailProps {
  novelChapter: INovelChapter;
}

export const Detail: React.FC<PageProps<{}, IDetailProps>> = ({ pageContext: { novelChapter } }) => {
  return (
    <div className={styles.detail}>
      <header className="header">
        <div className="headerInner">
          <Link to="/san-guo-yan-yi">
            <img src={require('./assets/back.svg')} />
            <span>&emsp;返回章节列表</span>
          </Link>

          <span className="chapterInfo">{novelChapter.title}</span>
        </div>
      </header>
      <div className="articleContent">
        <section className="articleInner">
          <h1>{novelChapter.title.replace('《三国演义》', '').replace(/^第(.*?)回\s?/, (word) => `${word}\n`)}</h1>
          <article style={{ whiteSpace: 'pre' }}>{novelChapter.content}</article>
        </section>
      </div>
    </div>
  );
};
